import styled from "styled-components";

export const SummaryCard = styled.section`
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
    min-width: 0;
    max-width: 180px;
    box-sizing: border-box;
    margin-top: 15px;
    padding: 14px 16px;
    border: 1px solid var(--light-blue-4);
    border-radius: 8px;
    background-color: var(--light-1);
    cursor: pointer;
    transition: border-color 0.25s ease, box-shadow 0.25s ease;
    &:hover {
        border-color: var(--purple-3);
        box-shadow: 0 6px 18px rgba(43, 56, 97, 0.08);
    }
    &.disabled {
        cursor: default;
        opacity: 0.75;
        box-shadow: none;
    }
    &.error {
        border-color: var(--red-2);
    }
`;

export const SummaryCardHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
`;

export const SummaryCardTitle = styled.span`
    color: var(--dark-1);
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
`;

export const TooltipTrigger = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const TooltipContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
`;

export const TooltipItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
`;

export const TooltipTime = styled.span`
    color: var(--light-1);
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
`;

export const TooltipDate = styled.span`
    color: var(--light-1);
    font-size: 13px;
    line-height: 17px;
`;

export const TooltipEllipsis = styled.span`
    color: var(--light-1);
    font-size: 16px;
    line-height: 12px;
`;
